export const CACHE_KEYS = Object.freeze({
  donors: 'donors'
})
